<template>
  <div>
    <Nav></Nav>
    <PageHeader>
      <ZoneRole
        :need-toast="true"
        :onSelectRole="onSelectRole"
        ref="groupDetailZoneRoleComponent"
        v-if="loginState.openid"
      ></ZoneRole>
    </PageHeader>
    <div class="main">
      <!-- 未参团用户视图 -->
      <div class="going_box border_box" v-if="!pageInitLoading && !isJoiner">
        <div class="corner"></div>
        <div class="corner"></div>
        <div class="corner"></div>
        <div class="corner"></div>

        <img
          alt
          class="title"
          src="../../../ui/LianPoH5/images/going_box_title.png"
          v-if="userTuanStatus == 'on'"
        />
        <img
          alt
          class="title cancle"
          src="../../../ui/LianPoH5/images/going_box_title_cancle.png"
          v-else
        />

        <div class="time_text" v-if="userTuanStatus == 'on'">
          团倒计时：
          <CountDown :endTime="userTuanDetail.tuan_end"></CountDown>
        </div>
        <div class="time_text" v-else>继续单人秒杀或发起礼包拼团吧</div>

        <div v-if="joiner && joiner.length">
          <div :key="'joinerItemTop' + index" v-for="(joinerItem, index) in joiner">
            <div class="user_info">
              <JoinerItem :joinerItem="joinerItem"></JoinerItem>
              <!-- 根据团状态：on-立即参团按钮；over-已成团标签；off-团结束标签 -->
              <div class="team_success_box" v-if="userTuanStatus == 'over'">
                <div class="success"></div>
              </div>
              <div class="team_fail_box" v-if="userTuanStatus == 'off'">
                <div class="fail"></div>
              </div>
            </div>
            <div style="height: 8px;"></div>
          </div>
          <div class="user_info" v-if="userTuanStatus == 'on'">
            <div class="user">
              <div @click="joinTuanPrompt" class="user_img">
                <img alt src="../../../ui/LianPoH5/images/team_going_add.png" />
              </div>
              <div class="user_name">待加入</div>
            </div>
            <div @click="joinTuanPrompt" class="btn">立即参团</div>
          </div>
          <img
            alt
            class="goning_box_tip_text"
            src="../../../ui/LianPoH5/images/goning_box_tip_text.png"
            v-if="userTuanStatus == 'on'"
          />
        </div>

        <!-- 兼容空团（开团了，没人参团） -->
        <div v-else>
          <div class="user_info">
            <div class="user">
              <div class="user_img">
                <img alt src="../../../ui/LianPoH5/images/team_going_add.png" />
              </div>
              <div class="user_name">待加入</div>
            </div>

            <div @click="joinTuanPrompt" class="btn" v-if="userTuanStatus == 'on'">立即参团</div>
            <div class="team_success_box" v-if="userTuanStatus == 'over'">
              <div class="success"></div>
            </div>
            <div class="team_fail_box" v-if="userTuanStatus == 'off'">
              <div class="fail"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- 物品信息视图 -->
      <ProductInfo
        :clickDirectPay="clickDirectPay"
        :openTuanPrompt="openTuanPrompt"
        :showPriceInfo="!pageInitLoading && !isJoiner"
      ></ProductInfo>

      <div @click="goToStrangerGroup" class="none_team_tip" v-if="!pageInitLoading && !isJoiner">
        <span>找不到团友? 参加其他用户的团吧~ >></span>
      </div>

      <!-- 已参团用户视图 -->
      <div class="build_box" v-if="!pageInitLoading && isJoiner && userTuanStatus == 'off'">
        <div class="title fail"></div>
        <div class="tip">
          团倒计时:
          <CountDown :endTime="userTuanDetail.tuan_end"></CountDown>
        </div>
        <div class="btn_box">
          <div @click="backToIndex" class="fail_btn">到首页单人秒杀皮肤或发起礼包拼团</div>
        </div>
      </div>
      <div
        :class="['going_box', 'team_going_box', 'team_fail_box', 'border_box']"
        v-if="!pageInitLoading && isJoiner && userTuanStatus == 'off'"
      >
        <div class="corner"></div>
        <div class="corner"></div>
        <div class="corner"></div>
        <div class="corner"></div>
        <img alt class="title" src="../../../ui/LianPoH5/images/team_going_box_title.png" />
        <div :key="'joinerItemBottom' + index" v-for="(joinerItem, index) in joiner">
          <div class="user_info">
            <JoinerItem :joinerItem="joinerItem"></JoinerItem>
            <div class="fail"></div>
          </div>
          <div style="height: 8px;"></div>
        </div>
        <div class="user_info">
          <div class="user">
            <div class="user_img">
              <img alt src="../../../ui/LianPoH5/images/team_going_add.png" />
            </div>
            <div class="user_name">待加入</div>
          </div>
          <div class="fail"></div>
        </div>
      </div>

      <div class="build_box" v-if="!pageInitLoading && isJoiner && userTuanStatus == 'on'">
        <div class="title"></div>
        <div class="tip">
          团倒计时:
          <CountDown :endTime="userTuanDetail.tuan_end"></CountDown>
        </div>
        <div :class="['btn_box', subscribeStatus === false ? '' : 'center_btn_box']">
          <div
            @click="guideSubscribe"
            class="build_invite_btn"
            v-if="subscribeStatus === false"
          >订阅成团发货信息</div>
          <div @click="setShareDialogStatus(true)" class="build_bespokes_btn">去邀请团友</div>
        </div>
      </div>
      <div
        class="going_box team_going_box border_box"
        v-if="!pageInitLoading && isJoiner && userTuanStatus == 'on'"
      >
        <div class="corner"></div>
        <div class="corner"></div>
        <div class="corner"></div>
        <div class="corner"></div>
        <img alt class="title" src="../../../ui/LianPoH5/images/team_going_box_title.png" />
        <div :key="'joinerItemBottom' + index" v-for="(joinerItem, index) in joiner">
          <div class="user_info">
            <JoinerItem :joinerItem="joinerItem"></JoinerItem>
            <div class="going"></div>
          </div>
          <div style="height: 8px;"></div>
        </div>
        <div class="user_info">
          <div class="user">
            <div @click="setShareDialogStatus(true)" class="user_img">
              <img alt src="../../../ui/LianPoH5/images/team_going_add.png" />
            </div>
            <div class="user_name">待加入</div>
          </div>
          <div class="going"></div>
        </div>
      </div>

      <div
        class="build_box build_success_box"
        v-if="!pageInitLoading && isJoiner && userTuanStatus == 'over'"
      >
        <div class="title"></div>
        <div class="tip">请到游戏邮箱中查收皮肤</div>
        <div :class="['btn_box']">
          <div @click="enterGame" class="build_invite_btn">去游戏</div>
          <div @click="goToStorePage" class="build_bespokes_btn">进入游戏专区</div>
        </div>
      </div>
      <div
        class="going_box team_success_box border_box"
        v-if="!pageInitLoading && isJoiner && userTuanStatus == 'over'"
      >
        <div class="corner"></div>
        <div class="corner"></div>
        <div class="corner"></div>
        <div class="corner"></div>
        <img alt class="title" src="../../../ui/LianPoH5/images/team_success_box_title.png" />
        <div :key="'joinerItemBottom' + index" v-for="(joinerItem, index) in joiner">
          <div class="user_info">
            <JoinerItem :joinerItem="joinerItem"></JoinerItem>
            <div class="success"></div>
          </div>
          <div style="height: 8px;"></div>
        </div>
      </div>

      <Rule></Rule>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex"
import Dialog from "./component/Dialog.vue"
import Nav from "./component/Nav.vue"
import CountDown from "./component/CountDown.vue"
import PageHeader from "./component/PageHeader.vue"
import ZoneRole from "./component/ZoneRole.vue"
import ProductInfo from "./component/ProductInfo.vue"
import Rule from "./component/Rule.vue"
import JoinerItem from "./component/JoinerItem.vue"
import tuanMixin from "./component/mixin.js"
import * as urlUtil from "../common/utils/url.js"

let configs = window.__midasStaticConfig_wzry_tuan_config

export default {
  name: "GroupDetail",
  mixins: [tuanMixin],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.initDetail()
    })
  },
  beforeRouteUpdate(to, from, next) {
    this.initDetail()
    next()
  },
  components: {
    Nav,
    PageHeader,
    ZoneRole,
    Dialog,
    CountDown,
    ProductInfo,
    Rule,
    JoinerItem
  },
  data() {
    return {
      pageInitLoading: true,

      isOpener: false,
      joiner: null,
      isJoiner: false,

      canSubmit: true
    }
  },
  computed: {
    ...mapGetters(["loginState", "userAgent", "gameInfoConfigs", "userTuanInfo", "pf", "accountType"]),
    userTuanDetail() {
      if (this.userTuanInfo && this.userTuanInfo.buytuan && this.userTuanInfo.buytuan.tuan && this.userTuanInfo.buytuan.tuan.tuan_info) {
        return this.userTuanInfo.buytuan.tuan.tuan_info
      } else {
        return null
      }
    },
    // 团状态：on-进行中；off-已结束；over-已成团
    userTuanStatus() {
      if (this.userTuanDetail && this.userTuanDetail.tuan_status) {
        return this.userTuanDetail.tuan_status
      } else {
        return null
      }
    }
  },
  methods: {
    ...mapActions([
      "getLoginState",
      "getGroupBuyings",
      "getMyGroup",
      "placeOrder",
      "reportUserAction",
      "setLoadingStart",
      "setLoadingEnd",
      "closePageLoading",
      "getSubscribeStatus",
      "goToStorePage",
      "setOnShareHandler"
    ]),
    initDetail() {
      this.getLoginState()
        .then(() => {
          this.closePageLoading()

          let tuanId = this.$route.params.id
          if (!tuanId) {
            this.$router.replace("/")
            return
          }

          setTimeout(() => {
            this.setOnShareHandler(tuanId)
          }, 0)

          this.setLoadingStart()
          this.canSubmit = false
          return this.getTuanInfo().then(() => {
            this.pageInitLoading = false

            this.reportUserAction({
              iformat: configs.REPORT.PAGEVIEW.DETAIL_SHOW,
              resultInfo: {
                isOpener: this.isOpener,
                isOpenIdJoiner: this.isOpenIdJoiner,
                isJoiner: this.isJoiner,
                tuanStatus: this.userTuanStatus
              }
            })

            this.setLoadingEnd()
            this.canSubmit = true
          })
        })
        .catch(error => {
          this.closePageLoading()

          this.setLoadingEnd()
          this.canSubmit = true

          this.catchInitError(error)
        })
    },

    getTuanInfo() {
      return Promise.all([this.getGroupBuyings(this.$route.params.id), this.$refs.groupDetailZoneRoleComponent.initZoneAndRole()]).then(
        () => {
          if (this.userTuanInfo && this.userTuanDetail) {
            // 账户隔离，如果团长身份和当前用户账户不同，则弹窗拦截
            if (
              this.userTuanDetail.header &&
              ((/^\d{1,13}$/.test(this.userTuanDetail.header) && this.accountType == "wechat") ||
                (!/^\d{1,13}$/.test(this.userTuanDetail.header) && this.accountType == "qq"))
            ) {
              this.openDialog({
                dialogContent: "<p class='text'>QQ大区与微信大区用户无法参与同一个团，去开一个新团吧~</p>",
                confirmText: "去拼团",
                cancelText: "查看陌生人团",
                hideClose: true,
                onConfirm: () => {
                  this.backToIndex()
                  this.openDialog()
                },
                onCancel: () => {
                  this.goToStrangerGroup()
                  this.openDialog()
                }
              })
            }

            if (this.userTuanStatus == "on" && this.subscribeStatus === null) {
              // 查询关注状态
              this.getSubscribeStatus()
            }

            // 当前用户是否是团长
            this.isOpener = this.userTuanInfo.user_comm_id == this.userTuanDetail.header
            this.joiner = this.userTuanDetail.join
            // 当前用户是否参加该团
            this.isOpenIdJoiner = this.joiner && this.joiner.some(person => person.uin == this.userTuanInfo.user_comm_id)
            // 当前大区是否参加该团
            this.isJoiner =
              this.joiner &&
              this.joiner.some(person => {
                let personZoneId = person && person.cgi_data && urlUtil.getParam("zoneid", person.cgi_data)
                return person.uin == this.userTuanInfo.user_comm_id && personZoneId == (this.selectedZone ? this.selectedZone.zone_id : 1)
              })
            return Promise.resolve()
          }
        }
      )
    },

    onSelectRole() {
      this.setLoadingStart()
      this.canSubmit = false

      this.getMyGroup()
        .then(tuanRes => {
          this.setLoadingEnd()
          this.canSubmit = true

          let selfTuanId = this.getSelfTuanId({ tuanRes: tuanRes, zoneId: this.selectedZone.zone_id, allStatus: false, noOff: true })

          // 如果当前团是我参与的团，则认为切换分区意思是查看新分区的团，要换团id
          if (this.isOpenIdJoiner) {
            if (selfTuanId) {
              if (!(this.$route.params && selfTuanId == this.$route.params.id)) {
                this.$router.replace(`/group-detail/${selfTuanId}`)
              } else {
                this.initDetail()
              }
            } else {
              this.$router.replace("/?noOff=1")
            }
          }
        })
        .catch(error => {
          this.setLoadingEnd()
          this.canSubmit = true

          this.catchInitError(error)
        })
    },

    joinTuanPrompt() {
      // 参数校验
      if (!this.orderPreCheck()) return

      // 虽然当前大区没有参团，但是账号参团了，也不能再参了 (一个账号，多大区，不能参同一个团)
      if (this.isOpenIdJoiner) {
        this.openDialog({
          dialogContent: "<p class='text'>您已经参加当前团了，不能重复参加哦~</p>",
          confirmText: "确认"
        })
        return
      }

      this.setLoadingStart()
      this.canSubmit = false

      this.getMyGroup()
        .then(res => {
          this.setLoadingEnd()
          this.canSubmit = true

          let selfTuanId = this.getSelfTuanId({ tuanRes: res, zoneId: this.selectedZone.zone_id, allStatus: false, noOff: true })

          if (selfTuanId) {
            // 有自己的团，则拦截参团
            this.openDialog({
              dialogContent: "<p class='text'>您在当前大区已经参与团购活动了哦，不能再参团啦~</p>",
              confirmText: "去看我的团",
              cancelText: "取消",
              onConfirm: () => {
                this.goToSelfTuanItem(selfTuanId)
              }
            })
            this.reportUserAction({
              iformat: configs.REPORT.PAGEVIEW.POPUP_JOINED_TUAN
            })
            return
          }

          this.openDialog({
            dialogContent: `<p class='text'>确认消耗 <span class="text_32" style="font-weight: 800;">${this.tuanProductConfig.price /
              10}点券${this.userAgent.iOS ? "" : "/￥" + this.tuanProductConfig.price / 100}</span> 购买${
              this.tuanProductConfig.productName
            } 并参与团购吗？礼包内含：廉颇·无尽征程+30荣耀积分。</p><p class='text'>${
              this.minJoinTuanNum
            }人即可拼团成功，成团后道具将发放到 <span>${this.selectedZone.zone_name} </span> 的游戏内部邮箱中哦，请及时领取~</p>`,
            confirmText: "确认",
            onConfirm: this.joinTuan
          })

          this.reportUserAction({
            iformat: configs.REPORT.PAGEVIEW.POPUP_PAY_CONFIRM
          })
        })
        .catch(error => {
          this.setLoadingEnd()
          this.canSubmit = true

          if (error && error.ret == 1414) {
            this.setToastMsg("您来晚了，活动已结束！")
          } else {
            this.setToastMsg(error && error.msg ? error.msg : "系统繁忙，请稍后再试")
          }
        })
    },

    joinTuan() {
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.JOIN_TUAN,
        resultInfo: `tuan_id=${this.$route.params.id}`
      })

      this.setLoadingStart()
      this.canSubmit = false

      return this.placeOrder({
        zoneid: this.selectedZone.zone_id,
        productId: this.tuanProductConfig.productId,
        productNum: 1,
        productName: this.tuanProductConfig.productName,
        gameId: [this.partitionInfo.area, "", "", this.partitionInfo.partition].join("_"),
        orderExtend: {
          is_tuan: 1
        }
      })
        .then(res => {
          this.setLoadingEnd()
          this.canSubmit = true

          this.handleOrderFilterInfo({
            orderRes: res,
            tuanId: this.$route.params.id,
            isTuanOwner: this.isOpener ? true : false
          })
        })
        .catch(error => {
          this.setLoadingEnd()
          this.canSubmit = true

          if (error && error.ret == 1414) {
            this.setToastMsg("您来晚了，活动已结束！")
          } else {
            this.setToastMsg(error && error.msg ? error.msg : "系统繁忙，请稍后再试")
          }
        })
    },

    backToIndex() {
      this.reportUserAction({
        iformat: configs.REPORT.CLICK.BACK_TO_INDEX_FROM_DETAIL,
        resultInfo: `tuan_id=${this.$route.params.id}`
      })
      this.$router.push("/?noOff=1")
    }
  }
}
</script>

<style scoped>
.build_success_box .build_invite_btn {
  filter: none;
  -webkit-filter: none;
  -moz-filter: none;
  -ms-filter: none;
  -o-filter: none;
  -webkit-filter: none;
}
.user .user_name {
  line-height: 0.6rem;
}
</style>
